import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Severity } from '../../../types/general-types';

@Component({
  selector: 'ces-status-dot',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ces-status-dot.component.html',
  styleUrl: './ces-status-dot.component.scss',
})
export class CesStatusDotComponent implements OnInit {
  private readonly translate = inject(TranslocoService);

  @Input() title = '';
  @Input() severity: Severity = 'danger';

  ngOnInit(): void {
    if (!this.title) {
      this.title = this.translate.translate('common.labels.valueModified');
    }
  }

  get class() {
    switch (this.severity) {
      case 'danger':
        return 'bg-red-100';
      case 'warn':
        return 'bg-yellow-100';
      case 'info':
        return 'bg-blue-100';
      case 'success':
        return 'bg-green-100';
      default:
        return 'bg-(--surface-2)';
    }
  }
}
